import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-pending-time-off-report',
    templateUrl: './pending-time-off-report.component.html',
    styleUrls: ['./pending-time-off-report.component.scss']
})
export class PendingTimeOffReportComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

} 